import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row card rounded-0" }
const _hoisted_3 = { class: "col-12 card-header" }
const _hoisted_4 = { class: "d-inline" }
const _hoisted_5 = { class: "col-12 card-body" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table table-striped" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "d-block" }
const _hoisted_17 = { class: "d-block" }
const _hoisted_18 = { class: "d-block" }
const _hoisted_19 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_20 = { class: "table table-striped" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }
const _hoisted_28 = { key: 7 }
const _hoisted_29 = { key: 8 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_33 = { class: "table table-striped" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_43 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_44 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_45 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_46 = {
  key: 4,
  class: "mb-4"
}
const _hoisted_47 = {
  key: 5,
  class: "mb-4"
}
const _hoisted_48 = {
  key: 6,
  class: "mb-4"
}
const _hoisted_49 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_50 = { class: "table table-striped" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = ["href"]
const _hoisted_58 = { key: 4 }
const _hoisted_59 = ["src"]
const _hoisted_60 = { key: 5 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "mb-3" }
const _hoisted_65 = { key: 2 }
const _hoisted_66 = { class: "mb-3" }
const _hoisted_67 = { key: 3 }
const _hoisted_68 = { key: 4 }
const _hoisted_69 = { key: 5 }
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = { key: 6 }
const _hoisted_72 = { key: 7 }
const _hoisted_73 = { class: "mb-3" }
const _hoisted_74 = { key: 8 }
const _hoisted_75 = { class: "mb-3 client-admin-partners py-4 px-4" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = ["disabled", "onUpdate:modelValue"]
const _hoisted_78 = { key: 9 }
const _hoisted_79 = { class: "mb-3 client-admin-partners py-4 px-4" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = ["disabled", "onUpdate:modelValue"]
const _hoisted_82 = { key: 10 }
const _hoisted_83 = { key: 11 }
const _hoisted_84 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.err_msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[85] || (_cache[85] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
            _createElementVNode("div", { class: "col-12 text-center" }, [
              _createElementVNode("h2", { class: "my-3 fw-bold" }, "User Management")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.user.name), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary float-end return-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({name:'management.users'})))
              }, "Return to User List")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.user.image_location,
                  class: "rounded-circle",
                  width: "100"
                }, null, 8, _hoisted_7),
                _createElementVNode("h4", null, _toDisplayString(_ctx.user.name), 1),
                _createElementVNode("h5", null, "ID: " + _toDisplayString(_ctx.user.id) + " | " + _toDisplayString(_ctx.user.email) + " | " + _toDisplayString(_ctx.user.mobile_number), 1),
                (_ctx.user.mobile_verified_at)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_8, "Mobile Verified " + _toDisplayString(_ctx.moment(_ctx.user.mobile_verified_at).format('MM/DD/YY h:mm a')), 1))
                  : (_openBlock(), _createElementBlock("h5", _hoisted_9, "Mobile not verified")),
                _cache[26] || (_cache[26] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              _createElementVNode("div", null, [
                _cache[28] || (_cache[28] = _createElementVNode("h4", null, "Partners", -1)),
                (_ctx.user.partners.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("table", _hoisted_11, [
                        _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Partner"),
                            _createElementVNode("th", null, "Auto Login")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.partners, (partner) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: partner.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(partner.long_name) + " - " + _toDisplayString(partner.slug), 1),
                              _createElementVNode("td", null, _toDisplayString(partner.al_link), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_12, "User not associated to any partners")),
                _cache[29] || (_cache[29] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              (_ctx.store.getters.hasPermission('user.edit'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[30] || (_cache[30] = _createElementVNode("h4", null, "Update Password", -1)),
                    _cache[31] || (_cache[31] = _createElementVNode("small", { class: "d-block mb-4" }, "Password must be at least 8 characters long", -1)),
                    _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block" }, "Enter New Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "d-block mb-4",
                      type: "password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block" }, "Confirm Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "d-block mb-4",
                      type: "password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirm_password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.confirm_password]
                    ]),
                    (_ctx.password_error.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.password_error), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-primary my-4",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePassword()))
                    }, "Update Password"),
                    _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.store.getters.hasPermission('user.edit'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[38] || (_cache[38] = _createElementVNode("h4", null, "Notification Settings", -1)),
                    _createElementVNode("label", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enable_email) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.enable_email]
                      ]),
                      _cache[35] || (_cache[35] = _createTextVNode(" Email"))
                    ]),
                    _createElementVNode("label", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.enable_sms) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.enable_sms]
                      ]),
                      _cache[36] || (_cache[36] = _createTextVNode(" SMS"))
                    ]),
                    _createElementVNode("label", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.enable_autologin) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.enable_autologin]
                      ]),
                      _cache[37] || (_cache[37] = _createTextVNode(" Auto Login"))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-primary my-4",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateNotificationSettings()))
                    }, "Update Settings"),
                    _cache[39] || (_cache[39] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _cache[41] || (_cache[41] = _createElementVNode("h4", null, "Visits", -1)),
                (_ctx.visits.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("table", _hoisted_20, [
                        _cache[40] || (_cache[40] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Scenario"),
                            _createElementVNode("th", null, "Partner"),
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Role"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "View")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visits.slice(_ctx.visits_page_start,_ctx.visits_page_end), (visit) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: visit.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(visit.scenario.patient_name), 1),
                              _createElementVNode("td", null, _toDisplayString(visit.partner.slug), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.moment(visit.start_time).format('MM/DD/YY h:mm a')) + " - " + _toDisplayString(visit.timezone.title), 1),
                              (visit.learner_user_id == _ctx.user.id)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_21, "Learner"))
                                : (visit.sp_user_id == _ctx.user.id)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_22, "SP"))
                                  : (visit.observer_users.filter(obs => obs.user_id == _ctx.user.id))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, "Observer"))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_24, "-")),
                              (visit.is_canceled)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_25, "Canceled"))
                                : (visit.no_show)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_26, "No Show"))
                                  : (visit.learner_technical_issue)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_27, "Learner Technical Issue"))
                                    : (visit.is_complete)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_28, "Completed"))
                                      : (_openBlock(), _createElementBlock("td", _hoisted_29, "Scheduled")),
                              _createElementVNode("td", null, [
                                _createElementVNode("i", {
                                  class: "fas fa-arrow-circle-right text-primary",
                                  onClick: ($event: any) => (_ctx.router.push({name:'visit',params:{visit_id:visit.id}}))
                                }, null, 8, _hoisted_30)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (_ctx.visits.length > 10)
                        ? (_openBlock(), _createBlock(_component_pagination, {
                            key: 0,
                            items: _ctx.visits,
                            page_start: _ctx.visits_page_start,
                            page_end: _ctx.visits_page_end,
                            onNextPage: _ctx.nextPageVisits,
                            onPreviousPage: _ctx.previousPageVisits,
                            label: 'Visits'
                          }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_31, "User not associated to any visits")),
                _cache[42] || (_cache[42] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              _createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("h4", null, "Training Sessions", -1)),
                (_ctx.training_sessions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("table", _hoisted_33, [
                        _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Type"),
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Role"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "View")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_sessions.slice(_ctx.training_sessions_page_start,_ctx.training_sessions_page_end), (training_session) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: training_session.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(training_session.type.name), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.moment(training_session.start_time).format('MM/DD/YY h:mm a')) + " - " + _toDisplayString(training_session.timezone.title), 1),
                              (training_session.trainer_user_id == _ctx.user.id)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, "Trainer"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_35, "Trainee")),
                              (training_session.is_canceled)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_36, "Canceled"))
                                : (training_session.is_complete)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_37, "Complete"))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_38, "Scheduled")),
                              _createElementVNode("td", null, [
                                _createElementVNode("i", {
                                  class: "fas fa-arrow-circle-right text-primary",
                                  onClick: ($event: any) => (_ctx.router.push({name:'training',params:{training_session_id:training_session.id}}))
                                }, null, 8, _hoisted_39)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (_ctx.training_sessions.length > 10)
                        ? (_openBlock(), _createBlock(_component_pagination, {
                            key: 0,
                            items: _ctx.training_sessions,
                            page_start: _ctx.training_sessions_page_start,
                            page_end: _ctx.training_sessions_page_end,
                            onNextPage: _ctx.nextPageTrainingSessions,
                            onPreviousPage: _ctx.previousPageTrainingSessions,
                            label: 'Training Sessions'
                          }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_40, "User not associated to any training sessions")),
                _cache[45] || (_cache[45] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              (_ctx.availabilities.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _cache[53] || (_cache[53] = _createElementVNode("h4", null, [
                      _createTextVNode("Availabilities "),
                      _createElementVNode("small", null, "(times are reflected in your time zone)")
                    ], -1)),
                    (_ctx.availabilities.filter(ava => ava.day == 'sunday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _cache[46] || (_cache[46] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Sunday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'sunday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'monday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _cache[47] || (_cache[47] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Monday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'monday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'tuesday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _cache[48] || (_cache[48] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Tuesday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'tuesday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'wednesday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _cache[49] || (_cache[49] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Wednesday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'wednesday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'thursday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _cache[50] || (_cache[50] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Thursday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'thursday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'friday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _cache[51] || (_cache[51] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Friday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'friday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.availabilities.filter(ava => ava.day == 'saturday').length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _cache[52] || (_cache[52] = _createElementVNode("p", { class: "mb-0" }, [
                            _createElementVNode("strong", null, "Saturday")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilities.filter(ava => ava.day == 'saturday'), (ava) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ava.id
                            }, _toDisplayString(_ctx.moment(ava.local_start_time,"HH:mm:ss").format('h:mm a')) + " - " + _toDisplayString(_ctx.moment(ava.local_end_time,"HH:mm:ss").format('h:mm a')), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[54] || (_cache[54] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _cache[56] || (_cache[56] = _createElementVNode("h4", null, "Interviews", -1)),
                (_ctx.interviews.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("table", _hoisted_50, [
                        _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "View")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interviews.slice(_ctx.interviews_page_start,_ctx.interviews_page_end), (interview) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: interview.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.moment(interview.start_time).format('MM/DD/YY h:mm a')) + " - " + _toDisplayString(interview.timezone.title), 1),
                              (interview.is_canceled)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_51, "Canceled"))
                                : (interview.is_complete)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_52, "Complete"))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_53, "Scheduled")),
                              _createElementVNode("td", null, [
                                _createElementVNode("i", {
                                  class: "fas fa-arrow-circle-right text-primary",
                                  onClick: ($event: any) => (_ctx.router.push({name:'interview',params:{interview_id:interview.id}}))
                                }, null, 8, _hoisted_54)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (_ctx.interviews.length > 10)
                        ? (_openBlock(), _createBlock(_component_pagination, {
                            key: 0,
                            items: _ctx.interviews,
                            page_start: _ctx.interviews_page_start,
                            page_end: _ctx.interviews_page_end,
                            onNextPage: _ctx.nextPageInterviews,
                            onPreviousPage: _ctx.previousPageInterviews,
                            label: 'Interviews'
                          }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_55, "User not associated to any interviews")),
                _cache[57] || (_cache[57] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              (_ctx.user.resume !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    (_ctx.user.resume !==null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.user.resume,
                          download: ""
                        }, "Download Resume", 8, _hoisted_57))
                      : _createCommentVNode("", true),
                    _cache[58] || (_cache[58] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user.headshot !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _cache[59] || (_cache[59] = _createElementVNode("p", null, "Headshot (right click and select \"Save Image As\" to download)", -1)),
                    _createElementVNode("img", {
                      class: "w-100",
                      src: _ctx.user.headshot
                    }, null, 8, _hoisted_59),
                    _cache[60] || (_cache[60] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.store.getters.hasPermission('user_role.edit'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _cache[83] || (_cache[83] = _createElementVNode("h4", null, "Roles", -1)),
                    (_ctx.store.getters.hasPermission('user_role.standardized_patient'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.SP]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.SP]]
                            ]),
                            _cache[61] || (_cache[61] = _createTextVNode(" Standardized Patient"))
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _cache[62] || (_cache[62] = _createElementVNode("small", null, "Rate:", -1)),
                            _cache[63] || (_cache[63] = _createTextVNode()),
                            _createVNode(_component_currency_input, {
                              modelValue: _ctx.role_rates[_ctx.UserRole.SP],
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.role_rates[_ctx.UserRole.SP]) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.observer'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.OBSERVER]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.OBSERVER]]
                            ]),
                            _cache[64] || (_cache[64] = _createTextVNode(" Observer"))
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _cache[65] || (_cache[65] = _createElementVNode("small", null, "Rate:", -1)),
                            _cache[66] || (_cache[66] = _createTextVNode()),
                            _createVNode(_component_currency_input, {
                              modelValue: _ctx.role_rates[_ctx.UserRole.OBSERVER],
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.role_rates[_ctx.UserRole.OBSERVER]) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.trainer'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.TRAINER]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.TRAINER]]
                            ]),
                            _cache[67] || (_cache[67] = _createTextVNode(" Trainer"))
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _cache[68] || (_cache[68] = _createElementVNode("small", null, "Rate:", -1)),
                            _cache[69] || (_cache[69] = _createTextVNode()),
                            _createVNode(_component_currency_input, {
                              modelValue: _ctx.role_rates[_ctx.UserRole.TRAINER],
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.role_rates[_ctx.UserRole.TRAINER]) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.reviewer'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.REVIEWER]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.REVIEWER]]
                            ]),
                            _cache[70] || (_cache[70] = _createTextVNode(" Reviewer"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.author'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.AUTHOR]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.AUTHOR]]
                            ]),
                            _cache[71] || (_cache[71] = _createTextVNode(" SP-ED Author"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.author'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selected_roles['simclusive_author']) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles['simclusive_author']]
                            ]),
                            _cache[72] || (_cache[72] = _createTextVNode(" Simclusive Author"))
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _cache[73] || (_cache[73] = _createElementVNode("small", null, "Rate:", -1)),
                            _cache[74] || (_cache[74] = _createTextVNode()),
                            _createVNode(_component_currency_input, {
                              modelValue: _ctx.role_rates['simclusive_author'],
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.role_rates['simclusive_author']) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.admin'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.ADMIN]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.ADMIN]]
                            ]),
                            _cache[75] || (_cache[75] = _createTextVNode(" Admin"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.head_trainer'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.HEADTRAINER]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.HEADTRAINER]]
                            ]),
                            _cache[76] || (_cache[76] = _createTextVNode(" Head Trainer"))
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _cache[77] || (_cache[77] = _createElementVNode("small", null, "Rate:", -1)),
                            _cache[78] || (_cache[78] = _createTextVNode()),
                            _createVNode(_component_currency_input, {
                              modelValue: _ctx.role_rates[_ctx.UserRole.HEADTRAINER],
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.role_rates[_ctx.UserRole.HEADTRAINER]) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.client_admin'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.CLIENTADMIN]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.CLIENTADMIN]]
                            ]),
                            _cache[79] || (_cache[79] = _createTextVNode(" SP-ED Client Admin"))
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "col-sm-12 col-md-6",
                                  key: partner.id
                                }, [
                                  _createElementVNode("label", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: !_ctx.selected_roles[_ctx.UserRole.CLIENTADMIN],
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.client_partners[partner.id]) = $event)
                                    }, null, 8, _hoisted_77), [
                                      [_vModelCheckbox, _ctx.client_partners[partner.id]]
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(partner.short_name), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.client_admin'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selected_roles['simclusive_client_admin']) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles['simclusive_client_admin']]
                            ]),
                            _cache[80] || (_cache[80] = _createTextVNode(" Simclusive Client Admin"))
                          ]),
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sim_partners, (partner) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "col-sm-12 col-md-6",
                                  key: partner.id
                                }, [
                                  _createElementVNode("label", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: !_ctx.selected_roles['simclusive_client_admin'],
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.sim_client_partners[partner.id]) = $event)
                                    }, null, 8, _hoisted_81), [
                                      [_vModelCheckbox, _ctx.sim_client_partners[partner.id]]
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(partner.short_name), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.exclude_from_reports'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.EXCLUDEFROMREPORTS]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.EXCLUDEFROMREPORTS]]
                            ]),
                            _cache[81] || (_cache[81] = _createTextVNode(" Exclude From Reports"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('user_role.report_manager'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selected_roles[_ctx.UserRole.REPORTMANAGER]) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.selected_roles[_ctx.UserRole.REPORTMANAGER]]
                            ]),
                            _cache[82] || (_cache[82] = _createTextVNode(" Report Manager"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-primary my-4",
                      onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.updateRoles && _ctx.updateRoles(...args)))
                    }, "Update Roles"),
                    _cache[84] || (_cache[84] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.err_msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
            _cache[86] || (_cache[86] = _createElementVNode("h4", null, "Error Loading Users", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}